import { catchError, map, of, tap } from 'rxjs';

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RemitterService } from '@services/remitter.service';
import { LOGIN_URL, NOT_ALLOW_REMITTER_STATUSES, QUERY_PARAMS, TOKEN_KEY } from '@shared/constants';
import { FLUTTER_FUNCTIONS } from '@shared/helpers/flutter-functions';

export const authGuard: CanActivateFn = (route, state) => {
  const paramToken = route.queryParamMap.get(TOKEN_KEY);
  if (paramToken) {
    localStorage.setItem(TOKEN_KEY, paramToken);
  }
  const accessToken = paramToken ? paramToken : localStorage.getItem(TOKEN_KEY);
  const userId = localStorage.getItem('user.id');
  const router = inject(Router);
  const urlParam = route.queryParamMap.get(QUERY_PARAMS.FROM_URL);
  const fromURL = urlParam ?? LOGIN_URL;
  function handleNavigate() {
    if (fromURL === LOGIN_URL) {
      FLUTTER_FUNCTIONS.backToLogin();
      router.navigate([LOGIN_URL], {
        queryParams:
          state.url !== '/' && state.url !== '/dashboard' ? { returnUrl: state.url } : null
      });
      return;
    }
    router.navigate([fromURL]);
  }
  if (accessToken) {
    const remitterService = inject(RemitterService);
    return remitterService.getRemitterProfile().pipe(
      map(remitter => {
        return !NOT_ALLOW_REMITTER_STATUSES.includes(remitter.status);
      }),
      tap(isAllowed => {
        if (!isAllowed) {
          localStorage.removeItem(TOKEN_KEY);
          handleNavigate();
        }
      }),
      catchError(error => {
        return of(false).pipe(
          tap(() => {
            localStorage.removeItem(TOKEN_KEY);
            handleNavigate();
          })
        );
      })
    )
  }
  return of(false).pipe(
    tap(() => {
      handleNavigate();
    })
  );
};